
  import { api } from "@/utils/request";
  export default {
    data: () => ({
      selectedCategory: '',
      categories: [],
      slickOptions: {
        dots: false,
        infinite: false,
        useTransform: false,
        variableWidth: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }),
    methods: {
      onSelectCategory(item) {
        this.selectedCategory = item.categorySlug
        this.$emit('selected-category', item.categorySlug)
      },
    },
    async created() {
      try {
        const data = await api("categories");
        this.categories = [{ categoryName: 'Popular', categorySlug: 'popular' }];
        this.categories = this.categories.concat(data.result);
      } catch (e) {
        console.error(e);
      }
    },
  }
